import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Button, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, TablePagination, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import Modal from "../Modal";
import JobDescription from "../JobDescription";
import createInstance from "../../../api/axiosinstance";
import { useNavigate, useParams } from "react-router-dom";
import Popup from "../Popup";
import Toast from "../../../utils/toast";

const JobDescriptionManagementList = ({ onOpenJobDescription }) => {

  const aiDishaApi = createInstance("DISHA");
  const [isJobDescriptionOpen, setIsJobDescriptionOpen] = useState(false);
  const [jobListFromTable, setJobListFromTable] = useState([]);
  const navigator = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [deactivateId, setDeactiveId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [editOrView, setEditOrView] = useState("");
  const [viewJobId, setViewJobId] = useState("");
  const [viewEditJobDetails, setViewEditJobDetails] = useState({});
  const [yearsOfExpList, setYearsOfExpList] = useState([]);
  const [salaryRangeList, setSalaryRangeList] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [activeCities, setActiveCities] = useState([]);
  const [activeSkills, setActiveSkills] = useState([]);
  const [educationDetailsUg, setEducationDetailsUg] = useState([]);
  const [educationDetailsPg, setEducationDetailsPg] = useState([]);
  const [orgId, setOrgId] = useState("");
  const [jobId, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [city, setCity] = useState("");  
  const [state, setState] = useState("");
  const [salaryRange, setSalaryRange] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [requiredSkills, setRequiredSkills] = useState([]);
  const [additionalSkills, setAdditionalSkills] = useState("");
  const [functionalArea, setFunctionalArea] = useState("");
  const [designation, setDesignation] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [educationDetails, setEducationDetails] = useState([""]);
  const [benefits, setBenefits] = useState("");
  const [status, setStatus] = useState("");
  const [isOthersUg, setIsOthersUg] = useState(false);
  const [isOthersPg, setIsOthersPg] = useState(false);
  const [ugDegree, setUgDegree] = useState("");
  const [pgDegree, setPgDegree] = useState("");
  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID"+organizationId);
   
  const jobHeader = [{    id: "Job ID",
                          title: "Job Title",
                          experience: "Experience (in years)",
                          location: "Location",
                          salary: "Salary Range",
                          employ: "Employee Type",
                          status : "Status",
                          action: "Action"}];

  const [openPopup, setOpenPopup] = useState(false);
   
  useEffect(()=>{
      getAllJobs();
      getActiveSkills();
      
  },[]);

  const getAllJobs = async () => { 
   
    await aiDishaApi.get(`/all-job/?org_id=${organizationId}`)
    .then((response)=>{ 
        setJobListFromTable(response.data);
        console.log(response.data); 
    })
    .catch((error)=> {
        console.error("Error fetching list of jobs", error);
    })
  }

  //Search jobs based on Job Title
  const handleSearch = (event) => {
      setSearchTerm(event.target.value);
  };

  // Call the admin landing page to open Create New Job page
  const handleOpenJobDescription = () => { 
    onOpenJobDescription(); 
  }; 
  
  const handleViewEditJob = (jobId, reason)=>{
    console.log("JOB ID :" + jobId); 
    getSelectedJobDetails(jobId);
    getAllDropdownValues();
      getActiveCities();
      getActiveSkills();
      getUgDetails();
      getPgDetails();
    setOpenPopup(true);
    setEditOrView(reason);
    console.log("Reason"+reason);
  }

  const getSelectedJobDetails = async (jobId) =>{
    await aiDishaApi.get(`/get_jobdetail_by_job_id?job_id=${jobId}`)
      .then((response)=>{    
        copyJobDetails(response.data);    
        console.log(response.data);     
      })
      .catch((error)=> {
          console.error("Error fetching job details", error);
      })
  }

  const copyJobDetails = (job) => {
    setOrgId(job.org_id)
    setJobId(job.Job_ID);
    setState(job.state);
    setCity(job.city);
    setEmployeeType(job.employee_type);
    setRequiredSkills(job.required_skills);
   
    setFunctionalArea(job.functional_area);
    setDesignation(job.designation);
    setSalaryRange(job.Salary_range);
    setYearsOfExperience(job.experience_years);
    setJobTitle(job.job_title);
    setJobDescription(job.job_description);
    setAboutCompany(job.company_info);
    setResponsibility(job.responsibility);
    setStatus(job.status);
    setAdditionalSkills(job.additional_skills);
    setBenefits(job.benefits);

    //Extracting Ug anf PG degrees if Others(UG) and others(PG) 
    //were selected while creating the job
    var tempEducation = job.education;
    console.log(tempEducation);
    console.log(educationDetails);
    var othersUG = educationDetailsUg.includes(tempEducation[0]) ? false : true ;
    var othersPG = educationDetailsPg.includes(tempEducation[1]) ? false : true ;
    //If theres no PG details
    if(!tempEducation[1]){
      othersPG = false;
    }

    console.log("UGGGG : "+tempEducation[0]+","+othersUG);
    console.log("PGGGG : "+tempEducation[1]+","+othersPG);

    setUgDegree(othersUG ? tempEducation[0] : "");
    setPgDegree(othersPG ? tempEducation[1] : "");

    setEducationDetails(job.education);

  }

  //To get the State Name corresponding to the city selected by the user
  const getStateName = async (city) =>{
    setCity(city);
    await aiDishaApi.get(`/statenames_based_on_city?city=${city}`)
    .then((response)=>{
      response.data.state ? setState(response.data.state) : setState("");
      console.log("State is *********"+response.data.state);
    })
    .catch((error)=> {
    console.error("Error fetching state name for the given city", error);
    })
  }

  const setEduDetails = (event) => {
    console.log(event);
    setEducationDetails(event);

    setIsOthersUg( event.includes("Others(UG)") ? true : false );
    setIsOthersPg( event.includes("Others(PG)") ? true : false );

    setIsOthersUg( event.includes("Others(UG)") ? true : false );
    setIsOthersPg( event.includes("Others(PG)") ? true : false );
    
    // for (var i = 0;i<event?.length;i++){
    //   setIsOthersUg((event[i] == "Others(UG)") ? true : false);
    //   if(isOthersUg){
    //     break;
    //   }
    // }
    // for (var i = 0;i<event?.length;i++){
    //   setIsOthersUg((event[i] == "Others(UG)") ? true : false);
    //   if(isOthersUg){
    //     break;
    //   }
    // }
    // for (var i = 0;i<event?.length;i++){
    //   setIsOthersPg((event[i] == "Others(PG)") ? true : false);
    //   if(isOthersPg){
    //     break;
    //   }
    // }
    // for (var i = 0;i<event?.length;i++){
    //   setIsOthersPg((event[i] == "Others(PG)") ? true : false);
    //   if(isOthersPg){
    //     break;
    //   }
    // }
    console.log("UG others ? "+isOthersUg);
    console.log("PG others ? "+isOthersPg);

  }

  

  const getAllDropdownValues = async () => {
    await aiDishaApi.get('/job_all_dropdown')
      .then((response)=>{
        const values = response.data;
        setYearsOfExpList(values["experience_yrs"]);
        setSalaryRangeList(values["salary_range"]);
        setDesignations(values["designation"]);
        console.log(response.data);
      })
      .catch((error)=> {
      console.error("Error fetching the list of values for the drop downs", error);
      })
  }

  //To Fetch all the 'Active' cities (irrespective of the state or district)
  const getActiveCities = async () => {
    await aiDishaApi.get('/Cities/active')
    .then((response)=>{
      setActiveCities(response.data);
      console.log(response.data);
    })
    .catch((error)=>{
      console.error("Error fetching active cities"+error);
    })
  }

  // To get all 'active' skills from backend
  const getActiveSkills = async () => {
    await aiDishaApi.get('/skills-show/active')
    .then((response)=>{
      const skillData = response.data;
      setActiveSkills(skillData);
      console.log("checking skills values:",response.data);           
    })
    .catch((error)=>{
      console.error("Error fetching active skills"+error);
    })
  }

  //To get all Under Graduate courses from Backend
  const getUgDetails = async () => {
    await aiDishaApi.get('/undergraduate_degrees')
      .then((response)=>{
        setEducationDetailsUg(response.data);
        console.log("UG DETAILS : "+response.data);           
      })
      .catch((error)=>{
        console.error("Error fetching UG details"+error);
      })
  }

  //To get all Post Graduate courses from Backend
  const getPgDetails = async () => {
    await aiDishaApi.get('/postgraduate_degrees')
      .then((response)=>{
        setEducationDetailsPg(response.data);
        console.log(response.data);           
      })
      .catch((error)=>{
        console.error("Error fetching PG details"+error);
      })
  }

  const handleEditJob = async (event) =>{
    event.preventDefault();
      if (!jobTitle.trim()) {
        console.error("Job title cannot be empty");
        Toast.error("Job title cannot be empty");
        return;
      }

      if (!yearsOfExperience.trim) {
        console.error("Experience cannot be empty");
        Toast.error("Experience cannot be empty");
        return;
      }

      if (!city.trim()) {
        console.error("City cannot be empty");
        Toast.error("City cannot be empty");
        return;
      }

      if (!salaryRange) {
        console.error("Salary Range cannot be empty");
        Toast.error("Salary Range cannot be empty");
        return;
      }

      if (!employeeType.trim()) {
        console.error("Employee Type cannot be empty");
        Toast.error("Employee Type cannot be empty");
        return;
      }

      if (!jobDescription.trim()) {
        console.error("Job Description cannot be empty");
        Toast.error("Job Description cannot be empty");
        return;
      }
      if (!responsibility.trim()) {
        console.error("Responsibility cannot be empty");
        Toast.error("Responsibility cannot be empty");
        return;
      }

      if (requiredSkills.length==0) {
        console.error("Required Skills cannot be empty");
        Toast.error("Required Skills cannot be empty");
        return;
      }

      if (!aboutCompany.trim()) {
        console.error("Company details cannot be empty");
        Toast.error("Company details cannot be empty");
        return;
      }

      if (!designation) {
        console.error("Designation cannot be empty");
        Toast.error("Designation cannot be empty");
        return;
      }
    
      if (educationDetails.length==0) {
        console.error("Educational Details cannot be empty");
        Toast.error("Educational Details cannot be empty");
        return;
      }

      await aiDishaApi.put("/org-update-job/",
        {
           org_id : organizationId,
           job_title : jobTitle,
           job_description : jobDescription,
           company_info : aboutCompany,
           responsibility : responsibility,
           status : status,
           additional_skills : additionalSkills,
           benefits : benefits
        },
        { params:{
                  org_id : organizationId,
                  Job_ID : jobId,
                  city : city,
                  state : state,
                  emp_type : employeeType,
                  Required_Skills : requiredSkills,
                  Functional_area : functionalArea,
                  Education_Details : educationDetails,
                  designation : designation,
                  salary_range : salaryRange,        
                  experience_yrs : yearsOfExperience             
                },
          paramsSerializer: {
            indexes: null 
          }
        }).then((response)=>{             
          console.log(response.data);
          clearForm();
          handlePopupClose();
          Toast.success("Job updated successfully");
          })
          .catch((error)=> {
          console.error("Error updating job", error);
          });
  }

  const handlePopupClose = () =>{
    setOpenPopup(false);
    getAllJobs();
  }

  const rows = jobListFromTable.map((job)=>({
                  jobId : job.Job_ID,
                  jobTitle : job.job_title,
                  experience : job.experience_years,
                  location : job.city,
                  salaryRange : job.Salary_range,
                  employeeType: job.employee_type,
                  status : job.status
  }));

  const filteredJobData = rows.filter((row) => 
    row.jobTitle?.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  
  const handleDeactivateJob = async () => {
    
  };
    
  //Job Delete
  const handleModalOpen = (jobId) => {
    setDeactiveId(jobId);
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  }; 
        
  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
    
  //View Edit Job Details Modal
  const handleViewModalOpen = (jobId,reason) => {
    setIsViewModalOpen(true);
    setEditOrView(reason);
    setViewJobId(jobId);
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
  };
  const clearForm = () => {
    setJobTitle("");
    setYearsOfExperience("");
    setCity("");
    setState("");
    setSalaryRange("");
    setEmployeeType("");
    setJobDescription("");
    setResponsibility("");
    setRequiredSkills([]);
    setAdditionalSkills("");
    setFunctionalArea("");
    setDesignation("");
    setAboutCompany("");
    setBenefits("");
    setEducationDetails([]);
   }

  return (
    isJobDescriptionOpen ? (
      <Box
        sx={{
          marginTop: "25px",
          borderRadius: "10px",
          backgroundColor: "#33333",
          maxHeight: "calc(100vh - 120px)", // Set maximum height to fill the viewport
          overflowY: "auto", // Enable vertical scrolling
        }}
      >   
        <JobDescription />   
      </Box>
    ) :
    <div>
      <div>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
              marginTop: "auto",alignItems: "center",borderRadius: "10px",
              padding: "1% 1%",}}  >
          <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "5%" }}>
            <Typography sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}>
                Existing Jobs List
            </Typography>
          </Box>

          <Box gridColumn="span 6"
            sx={{ marginTop:"auto", textAlign:"left", marginBottom:"2%" , marginLeft:"8%"}}>
              <Paper sx={{
                      p: "2px 4px",display: "flex",width: "75%",
                      borderRadius: 2, backgroundColor: "#033538",
                  }} > 
                <IconButton type="button" sx={{ p: "8px", color: "white" }}
                    aria-label="search">
                    <SearchIcon /></IconButton>
                <InputBase
                    sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }} 
                    placeholder="Search by Job Title"
                    inputProps={{ "aria-label": "search google maps" }}
                    value={searchTerm} onChange={handleSearch} />
              </Paper>   
          </Box>

          <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "center",
              marginLeft: "50%" }}>
              <Button variant="contained" onClick={handleOpenJobDescription}
                  sx={{backgroundColor: "#033538",color: "white",
                      fontFamily: "poppins",}}>Create New Job</Button>          
          </Box>
        </Box>
        <Box xs={1} sx={{ backgroundColor: "#33333" }}>
          <Grid container spacing={1} sx={{ justifyContent: "center" }}>
            <Grid item xs={11}>
              <TableContainer component={Paper}
                        sx={{marginTop: "25px",borderRadius: "10px",}}>                       
                <Table size="small">
                  <TableHead sx={{ backgroundColor: "#033538" }}>
                    {jobHeader.map((job) => (
                      <TableRow key={job.id}>
                        <TableCell sx={{ color: "white", borderBottom: 0, 
                          borderLeft: "1px    solid black" }}>{job.id}</TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.title} </TableCell>                                   
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.experience}</TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.location}</TableCell>      
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.salary} </TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.employ} </TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {job.status}</TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                            {job.action}</TableCell>
                      </TableRow>
                    ))}
                  </TableHead>      
                  <TableBody>
                    {filteredJobData && filteredJobData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((n, index) => (
                        <TableRow
                            key={n.jobId}
                            sx={{ backgroundColor: "#3E3E3E", marginRight: "30px" }}>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.jobId} </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.jobTitle}</TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.experience} </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.location} </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.salaryRange}</TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {n.employeeType}</TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            <Paper sx={{ p: "2px 4px", display: "flex", width: "100%",
                                        borderRadius: 2,  border: "1px solid #A7A7A7",
                                        backgroundColor : (n.status == "Active" || n.status == "active") ? "greenyellow" : "red" }}>
                              {(n.status == "Active" || n.status == "active") ? "Open" : "Closed" }</Paper></TableCell>
                          <TableCell sx={{border: "1px solid black" ,color: "#A7A7A7",
                                          display: "flex",alignItems: "center",}}>
                            <Button variant="contained" sx={{backgroundColor: "black",
                              color: "#A7A7A7",marginRight: "5px",fontFamily: "poppins",
                              height: "30px",width: "40px"}} 
                              onClick={()=>handleViewEditJob(n.jobId,"Edit")}> 
                                Edit </Button>
                            <Button variant="contained"
                              sx={{backgroundColor: "black",
                              color: "#A7A7A7",marginRight: "10px",fontFamily: "poppins",
                              height: "30px",width: "40px",}}
                              onClick={()=>handleViewEditJob(n.jobId,"View")}>
                                View </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15]} component="div"
                    count={filteredJobData.length} rowsPerPage={rowsPerPage}
                    page={page} onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{backgroundColor: "#033538",color: "#B9B9B9",}}/>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
        
        <Modal
            isOpen={isModalOpen}
            onClose={handleModalClose}
            title="Job"
            action={() => handleDeactivateJob(deactivateId)}/>

        <Popup
          title = "View/Edit Job"
          openPopupVar = {openPopup}
          setOpenPopupMet = {setOpenPopup}>
          <div style={{display: "block", backgroundColor:"white", width:"100%", maxWidth:"1200px"}}>
          <div className="modal-header border-0">
              <label style={{color:"#033538",fontSize:"18px"}}>{editOrView} Job</label>
              <button type="button" className="btn-close" onClick={handlePopupClose}></button>
            </div>
           
            <form onSubmit={handleEditJob}>
                {/*First Row*/}
                <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="jobId" style={{fontFamily: "Poppins",fontSize: "12px",color: "#033538",}}>
                          Job ID </label>
                      <input type="text" name="jobId" className="form-control form-control-sm"
                        value={jobId} aria-label="Job ID" style={{ border: "none", width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "white", bgColor:"#033538"}} readOnly /> 
                      </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="jonTitle" style={{
                        fontFamily: "Poppins",fontSize: "12px",color: "#033538",}}>
                        Job Title</label>
                      <input type="text" name="jobTitle" className="form-control form-control-sm"
                        value={jobTitle} aria-label="Job Title" style={{ backgroundColor: "#033538",border: "none", width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}} 
                        disabled={editOrView=="View" ? true : false}
                        onChange={(e)=>setJobTitle(e.target.value)}/>                      
                      </div>
                    <div className="col-sm-4">
                      <label htmlFor="experience" style={{fontFamily: "Poppins",
                          fontSize: "12px",color: "#033538",}}>
                        Experience</label>
                      <select name="experience" className="form-select form-select-sm"
                        aria-label="Small select example" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                        value={yearsOfExperience}
                        disabled={editOrView=="View" ? true : false}
                        onChange={(e) => setYearsOfExperience(e.target.value)}
                      >
                        <option key="select" value="" disabled={true}>Select experience</option>
                        {yearsOfExpList.map((range)=>
                          <option key={range} value={range}>{range}</option>)}
                      </select>
                    </div>
                </div>
                  {/*  Second Row*/ }
                  <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                      <label htmlFor="city" style={{fontFamily: "Poppins",
                          fontSize: "12px",color: "#033538"}}>City</label>
                      <select name="city" className="form-select form-select-sm"
                        aria-label="Small select example" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                          value={city} 
                          disabled={editOrView=="View" ? true : false}
                          onChange={(e) => getStateName(e.target.value)}
                          >
                            <option key="select" value="" disabled={true}>Select city</option>
                        {activeCities.map((city)=>(
                          <option key={city.city_name} value={city.city_name}>{city.city_name}</option>))}</select>
                    </div>    
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="state" style={{label: "Disabled",
                          fontFamily: "Poppins",fontSize: "12px",color: "#033538"}}>
                          State</label>
                      <input type="text" name="state" className="form-control form-control-sm"
                        value={state} aria-label="Job Title"
                        style={{  backgroundColor: "#033538",border: "none", width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }} 
                        disabled={true} />                      
                    </div>
                    <div className="col-sm-4">
                      <label htmlFor="salaryRange" style={{fontFamily: "Poppins",
                          fontSize: "12px",color: "#033538"}}>Salary Range </label>
                      <select name="salaryRange" className="form-select form-select-sm"
                        aria-label="Small select example" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                        value={salaryRange} 
                        disabled={editOrView=="View" ? true : false}
                        onChange={(e) => setSalaryRange(e.target.value)}
                      >
                        <option key="select" value="" disabled={true}>Select salary range</option>
                        {salaryRangeList.map((range)=>
                          <option key={range} value={range}>{range}</option>)}
                      </select>
                    </div>
                  </div> 
                  {/* Third Row*/}
                  <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                      <label
                          htmlFor="employeeType" style={{fontFamily: "Poppins",
                          fontSize: "12px",color: "#033538"}}>Employee Type</label>
                      
                        <select name="employeeType" className="form-select form-select-sm"
                          aria-label="Small select example" style={{backgroundColor: "#033538",
                            color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                          value={employeeType}
                          disabled={editOrView == "View" ? true : false}
                          onChange={(e) => setEmployeeType(e.target.value)}
                        >
                          <option value="" disabled={true}>Select employee type</option>
                          <option value="Full Time">Full Time</option>
                          <option value="Part Time">Part Time</option>
                          <option value="Intern">Intern</option>
                          <option value="Contract">Contract</option>
                        </select>
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="jobDescription" style={{
                        label: "Disabled", fontFamily: "Poppins",fontSize: "12px",
                        color: "#033538",}}>Job Description</label>
                      <input type="text" name="jobDescription" 
                        className="form-control form-control-sm" value={jobDescription} aria-label="Job Title" style={{ backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setJobDescription(e.target.value)}
                        /> 
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="responsibility"
                        style={{label: "Disabled",fontFamily: "Poppins",fontSize: "12px",
                        color: "#033538",}}>Responsibility</label>
                      <input type="text" name="responsibility" 
                        className="form-control form-control-sm" value={responsibility} aria-label="Job Title" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setResponsibility(e.target.value)}
                        /> 
                    </div>
                  </div>
                  {/* Fourth Row*/}
                  <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                      <label htmlFor="requiredSkills" style={{fontFamily: "Poppins",
                        fontSize: "12px",color: "#033538"}}>Required Skills</label>
                      <select name="requiredSkills" className="form-select form-select-sm"
                        aria-label="Small select example" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}} multiple={true}
                        value={requiredSkills}
                        disabled={editOrView == "View" ? true : false}
                        // onChange={(e) => setRequiredSkills(e.target.value)}
                        onChange={(e) => setRequiredSkills(Array.from(e.target.selectedOptions, option => option.value))}
                        >
                        {/* {Object.keys(activeSkills).map((index)=>(
                          <option key={activeSkills[index].skill_name} value={activeSkills[index].skill_name}>{activeSkills[index].skill_name}</option>
                        ))} */}
                        {activeSkills.map((skill) => (
    <option key={skill._id} value={skill.skill_name}>
      {skill.skill_name}
    </option>
  ))}
                        </select>
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="additionalSkills"
                        style={{label: "Disabled",fontFamily: "Poppins",
                          fontSize: "12px",color: "#033538"}}>Additional Skills</label>
                      <input type="text" name="additionalSkills"
                        className="form-control form-control-sm"
                        value={additionalSkills} aria-label="additional skills"
                        style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}} 
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setAdditionalSkills(e.target.value)}
                        /> 
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="functionalArea"
                        style={{label: "Disabled",fontFamily: "Poppins",fontSize: "12px",
                        color: "#033538"}}>Functional Area</label>
                      <input type="text" name="functionalArea"
                        className="form-control form-control-sm" value={functionalArea}
                        aria-label="functional area" style={{ backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setFunctionalArea(e.target.value)}
                      /> 
                    </div>
                  </div>
                  {/* Fifth Row*/}
                  <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                      <label htmlFor="designation" style={{ fontFamily: "Poppins",
                        fontSize: "12px",color: "#033538"}}>Designation </label>
                        <select name="designation" className="form-select form-select-sm"
                          aria-label="Small select example" style={{backgroundColor: "#033538",
                            color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}} value={designation} 
                            disabled={editOrView == "View" ? true : false}
                            onChange={(e) => setDesignation(e.target.value)}
                            >
                              <option key="select" value="">Select designation</option>
                          {designations.map((designation)=>(
                            <option key={designation} value={designation}>{designation}</option>
                          ))} </select>
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="aboutCompany" style={{label: "Disabled",
                        fontFamily: "Poppins",fontSize: "12px",color: "#033538"}}>
                          About Company</label>
                      <input type="text" name="aboutCompany"
                        className="form-control form-control-sm"
                        value={aboutCompany} aria-label="Job Title"
                        style={{ backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setAboutCompany(e.target.value)}
                      /> 
                    </div>
                    <div className="col-sm-4">
                      <label className="aa" htmlFor="benefits" style={{
                        label: "Disabled", fontFamily: "Poppins", fontSize: "12px",
                        color: "#033538"}}>Benefits</label>
                      <input type="text" name="benefits" className="form-control form-control-sm"
                        value={benefits} aria-label="Job Title" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                        disabled={editOrView == "View" ? true : false}
                        onChange={(e)=>setBenefits(e.target.value)}
                        /> 
                    </div>
                  </div>
                  {/* Sixth Row*/}
                  <div className="row" style={{ margin: "0% 2%" }}>
                    <div className="col-sm-4">
                        <label className="aa" htmlFor="status" style={{
                          label: "status", fontFamily: "Poppins", fontSize: "12px",
                          color: "#033538"}}>Status</label>
                        <select name="status" className="form-select form-select-sm"
                            aria-label="Small select example" style={{backgroundColor: "#033538",
                              color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080"}}
                            value={status}
                            disabled={editOrView == "View" ? true : false}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </select>
                      </div>
                      <div className="col-sm-4">
                        <InputLabel htmlFor="education" style={{ fontFamily: "Poppins",
                          fontSize: "12px", color: "#033538"}}>Education</InputLabel>
                          
                          <select
                            name="education" className="form-select form-select-sm"
                            aria-label="Small select example" style={{backgroundColor: "#033538",
                              color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "white"}} multiple={true} value={educationDetails}
                            disabled={editOrView == "View" ? true : false}
                            onChange={(e) => setEduDetails(e.target.value)}
                            >
                            <option color="black" key="ug" value="ug" disabled={true}>
                              Under Graduate</option>
                            {educationDetailsUg.map((degreeUg)=>(
                              <option key={degreeUg} value={degreeUg}>
                              {degreeUg}
                              </option>
                            ))}
                            <option color="black" key="pg" value="pg" disabled={true}>
                              Post Graduate</option>
                            {educationDetailsPg.map((degreePg)=>(
                              <option key={degreePg} value={degreePg}>
                              {degreePg}
                              </option>
                            ))}
                            </select>
                            
                      </div>
                      
                  </div>
                  {/*Seventh Row*/}
                  <div className="row" style={{ margin: "0% 2%" }}>
                  <div className="col-sm-4" >
                      <label className="aa" htmlFor="ugDegree" style={{
                        label: "Disabled", fontFamily: "Poppins", fontSize: "12px",
                        color: "#033538"}} hidden={(editOrView == "Edit" && isOthersUg) ? false : true }>Education Details UG</label>
                      <input type="text" name="benefits" className="form-control form-control-sm"
                        value={ugDegree} aria-label="UG Degree" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                        hidden={(editOrView == "Edit" && isOthersUg) ? false : true }
                        onChange={(e)=>setUgDegree(e.target.value)}
                        /> 
                    </div>
                    <div className="col-sm-4" >
                        <label className="aa" htmlFor="pgDegree" style={{
                          label: "Disabled", fontFamily: "Poppins", fontSize: "12px",
                          color: "#033538"}} hidden={(editOrView == "Edit" && isOthersPg)? false : true }>Education Details PG</label>
                        <input type="text" name="benefits" className="form-control form-control-sm"
                          value={pgDegree} aria-label="PG Degree" style={{backgroundColor: "#033538",
                            color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                         hidden={(editOrView == "Edit" && isOthersPg) ? false : true}
                          onChange={(e)=>setPgDegree(e.target.value)}
                          /> 
                      </div>
                    </div>
                    {/* Eighth Row */}
                  <div className="row" style={{ margin: "0% 2%" }}>
                  <div className="col-sm-4" hidden={editOrView == "View" ? false : true }>
                      <label className="aa" htmlFor="ugDegree" style={{
                        label: "Disabled", fontFamily: "Poppins", fontSize: "12px",
                        color: "#033538"}} >Education Details UG </label>
                      <input type="text" name="benefits" className="form-control form-control-sm"
                        value={ugDegree} aria-label="UG Degree" style={{backgroundColor: "#033538",
                          color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                        disabled={true}
                        
                        onChange={(e)=>setUgDegree(e.target.value)}
                        /> 
                    </div>
                    <div className="col-sm-4" hidden={editOrView == "View" ? false : true }>
                        <label className="aa" htmlFor="pgDegree" style={{
                          label: "Disabled", fontFamily: "Poppins", fontSize: "12px",
                          color: "#033538"}} >Education Details PG</label>
                        <input type="text" name="benefits" className="form-control form-control-sm"
                          value={pgDegree} aria-label="PG Degree" style={{backgroundColor: "#033538",
                            color: "white",border: "none",width:"100%",fontFamily: "Poppins",fontSize: "12px",color: "#808080" }}
                          disabled={true}
                          
                          onChange={(e)=>setPgDegree(e.target.value)}
                          /> 
                      </div>
                    </div>
                  
                {/* Buttons */}
                  <div className="modal-footer d-flex flex-row justify-content-right border-0"
                  >
                    <button type="button" className="btn btn-sm rounded-2 fw-medium"
                      onClick={clearForm} style={{color: "#033538",width: "120px",
                        border: "1px solid #1E1E1E"}}
                        hidden={editOrView == "View" ? true : false}>
                      Clear</button>
                    <button type="submit" className="btn btn-sm rounded-2 fw-medium"
                      style={{backgroundColor: "#033538",color: "white",width: "120px"}}
                      hidden={editOrView == "View" ? true : false}>
                      Submit</button>
                  </div>
                  <br/>
                  <br/>
                  <br/>
            </form>
          </div>
        </Popup> 
      </div>    
    </div>    
  );
};

export default JobDescriptionManagementList;
